import { useContext } from "react";
import { AppContext } from "contexts";

export function useApp() {
  const { configuration } = useContext(AppContext);
  return {
    configuration,
  };
}
